<nz-layout class="app-layout">
  <nz-layout>
    <nz-header>
      <div class="app-header">
        @if (isMobile()) {
          <div class="logo logo-handset">
            <a [routerLink]="['/']">
              <img src="/assets/icons/logo-webapp.svg" alt="logo" />
              <!-- <h1>
                <span class="text"> Interview AI</span>
              </h1> -->
            </a>
          </div>
        } @else {
          <div class="logo logo-normal">
            <a [routerLink]="['/']">
              <img src="/assets/icons/logo-webapp.svg" alt="logo" />
              <!-- <h1>
                <span class="text"> Interview AI</span>
              </h1> -->
            </a>
          </div>
        }

        <div class="buttons">
          @if (isMobile()) {
            <button class="credit-btn" nz-button nzType="text" nzSize="small" (click)="onPointsClick()">
              <span>{{ credits() }} points</span>
            </button>
          }

          <nz-avatar
            class="portrait"
            [nzSrc]="portraitUrl()"
            nz-dropdown
            [nzDropdownMenu]="portraitMenu"
            [nzShape]="'circle'"
          ></nz-avatar>

          <nz-dropdown-menu #portraitMenu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item (click)="onMyAccountClick()">
                <div class="horizontal">
                  <span nz-icon style="font-size: 18px" class="material-icons-outlined">account_circle</span>
                  <span>My Account</span>
                </div>
              </li>
              <li nz-menu-item (click)="onWalletClick()">
                <div class="horizontal">
                  <span nz-icon style="font-size: 18px" class="material-icons-outlined">account_balance_wallet</span>
                  <span>History</span>
                </div>
              </li>
              <li nz-menu-item (click)="onLogoutClick()">
                <div class="horizontal">
                  <span nz-icon style="font-size: 18px" class="material-icons-outlined">logout</span>
                  <span>Logout</span>
                </div>
              </li>
            </ul>
          </nz-dropdown-menu>
        </div>
      </div>
    </nz-header>

    <nz-layout>
      @if (isMobile()) {
        <nz-sider class="handset-sider" nzCollapsible [(nzCollapsed)]="isCollapsed" nzWidth="200px">
          <ul nz-menu nzMode="inline">
            <li nz-menu-item nzMatchRouter>
              <a class="horizontal" [routerLink]="['/', 'get-started']">
                <span nz-icon style="font-size: 16px" class="material-icons-outlined">flag</span>
                <span class="menu-text">How to start</span>
              </a>
            </li>
            <li nz-submenu [nzTitle]="titleTpl">
              <ng-template #titleTpl>
                <div class="horizontal">
                  <span nz-icon style="font-size: 16px" class="material-icons-outlined">upload_file</span>
                  <span class="menu-text">My Materials</span>
                </div>
              </ng-template>
              <ul>
                <li class="sub-menu-item" nz-menu-item nzMatchRouter>
                  <a [routerLink]="['/', 'target-positions']">
                    <span class="menu-text">Target Position</span>
                  </a>
                </li>
                <li class="sub-menu-item" nz-menu-item nzMatchRouter>
                  <a [routerLink]="['/', 'resume']">
                    <span class="menu-text">Resume</span>
                  </a>
                </li>
                <!-- <li nz-menu-item nzMatchRouter>
                  <a [routerLink]="['/', 'behavioral-questions']"> Behavioral Questions </a>
                </li> -->
              </ul>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a class="horizontal" [routerLink]="['/', 'mock-interview']">
                <span nz-icon style="font-size: 16px" class="material-icons-outlined">headset_mic</span>
                <span class="menu-text">Mock Interview (Beta)</span>
              </a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a class="horizontal" [routerLink]="['/', 'interview']">
                <span nz-icon style="font-size: 16px" class="material-icons-outlined">personal_video</span>
                <span class="menu-text">Interview Assistant</span>
              </a>
            </li>
          </ul>
        </nz-sider>
      } @else {
        <nz-sider class="desktop-sider">
          <ul nz-menu nzMode="inline">
            <li nz-menu-item nzMatchRouter>
              <a [routerLink]="['/', 'get-started']">
                <span nz-icon style="font-size: 18px" class="material-icons-outlined">start</span>
                <span>How to start</span>
              </a>
            </li>
            <li nz-submenu [nzTitle]="titleTpl" [nzOpen]="true">
              <ng-template #titleTpl>
                <span nz-icon style="font-size: 18px" class="material-icons-outlined">upload_file</span>
                <span>My Materials</span>
              </ng-template>
              <ul>
                <li nz-menu-item nzMatchRouter>
                  <a [routerLink]="['/', 'target-positions']"> Target Position </a>
                </li>
                <li nz-menu-item nzMatchRouter>
                  <a [routerLink]="['/', 'resume']"> Resume </a>
                </li>
                <!-- <li nz-menu-item nzMatchRouter>
                  <a [routerLink]="['/', 'behavioral-questions']"> Behavioral Questions </a>
                </li> -->
              </ul>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a [routerLink]="['/', 'mock-interview']">
                <span nz-icon style="font-size: 18px" class="material-icons-outlined">headset_mic</span>
                <span>Mock Interview (Beta)</span>
              </a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a [routerLink]="['/', 'interview']">
                <span nz-icon style="font-size: 18px" class="material-icons-outlined">personal_video</span>
                <span>Interview Assistant</span>
              </a>
            </li>
          </ul>

          @if (!isMobile()) {
            <div class="credits credits-desktop">
              <div class="credits-title">
                <b>{{ credits() }} points</b><span> left</span>
              </div>

              @if (credits() < 10) {
                <div class="warning">Your balance is insufficient to launch an interview.</div>
              }
              <div class="credits-content">
                Launching interviews costs points:
                <ul>
                  <li>Normal interview: 10 points per interview</li>
                  <li>Coding interview: 15 points per interview</li>
                </ul>
              </div>

              <button nz-button nzType="default" nzSize="large" (click)="onGetMorePointsClick()">
                <span>Get More Points</span>
              </button>
            </div>

            <div class="version">
              {{ version() }}
            </div>
          }
        </nz-sider>
      }
      <nz-layout [ngClass]="isMobile() ? ['right-layout-mobile'] : ['right-layout']">
        <nz-content>
          <div class="body-content" [ngClass]="isMobile() ? ['body-content-handset'] : ['body-content-normal']">
            <ng-content></ng-content>
          </div>
        </nz-content>
        <nz-footer>
          <div class="footer">Copyright ©2024 360Interview AI. All rights reserved.</div>
        </nz-footer>
      </nz-layout>
    </nz-layout>
  </nz-layout>
</nz-layout>

<nz-modal
  [(nzVisible)]="isSendFeedbackVisible"
  nzTitle="Contact Support"
  (nzOnCancel)="handleSendFeedbackCancel()"
  [nzOkText]="'Send'"
  (nzOnOk)="handleSendFeedbackOk()"
>
  <ng-container *nzModalContent>
    <div class="vertical-large">
      <div class="vertical">
        <div class="field-name">Name</div>
        <input nz-input placeholder="Name" [(ngModel)]="name" />
      </div>

      <div class="vertical">
        <div class="field-name">Email</div>
        <input nz-input placeholder="Email" [(ngModel)]="email" />
      </div>

      <div class="vertical">
        <div class="field-name">Feedback</div>
        <textarea
          nz-input
          placeholder="Feedback"
          [(ngModel)]="feedback"
          [nzAutosize]="{ minRows: 2, maxRows: 6 }"
        ></textarea>
      </div>
    </div>
  </ng-container>
</nz-modal>

<app-content-modal
  [isVisible]="showMobileModal()"
  [title]="'Please sign in using a desktop computer :)'"
  [content]="
    'Please use a desktop or laptop computer with the Google Chrome browser to access 360Interview AI for full feature availability.'
  "
  [okText]="'Got it'"
></app-content-modal>

<!-- <app-content-modal
  [(isVisible)]="unlimitedPointsModal"
  [title]="'👋 Yo!'"
  [content]="
    'You\'ve been selected as a tester for our new version with unlimited interview points until our next update. We\'d appreciate any feedback on your experience :D'
  "
></app-content-modal> -->
